// src/components/auth/ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export function StudentRoute({ children }) {
  const { currentUser, userRole } = useAuth();
  if (!currentUser) return <Navigate to="/login" replace />;
  if (userRole === "admin") return <Navigate to="/admin" replace />;
  return children;
}

export function AdminRoute({ children }) {
  const { currentUser, userRole } = useAuth();
  if (!currentUser) return <Navigate to="/login" replace />;
  if (userRole !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
}

export function PublicOnlyRoute({ children }) {
  const { currentUser, userRole } = useAuth();
  if (currentUser) {
    return <Navigate to={userRole === "admin" ? "/admin" : "/dashboard"} replace />;
  }
  return children;
}
